import { Loader2 } from "lucide-react";

export default function OverlayLoader() {
  return (
    <div
      className="
        fixed inset-0 
        bg-black/50 
        z-10000 
        flex items-center justify-center
      "
    >
      <Loader2 className="h-10 w-10 animate-spin" style={{ color: "var(--color-brand-green)" }} />
    </div>
  );
}
